<template>
  <div>
    <Table
      resource="RootCategory"
      :actions="actions"
      :items="$store.getters['rootCategory/tableData']"
      :detail="$store.getters['rootCategory/detailData']"
      :fields="$store.getters['rootCategory/tableFields']"
      :pagination="$store.state.rootCategory.tablePagination"
      :keyword="$store.state.rootCategory.tableKeyword"
      :loading="$store.state.rootCategory.loadingTable"
      :filter="$store.state.rootCategory.tableFilter"
      :sort="$store.state.rootCategory.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('rootCategory/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('rootCategory/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('rootCategory/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('rootCategory/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('rootCategory/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('rootCategory/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('rootCategory/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('rootCategory/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('rootCategory/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('rootCategory/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
